<template>
  <div>
    <!-- Header -->
    <div class="page-header">
      <div class="page-title">
        <h4>Create Attribute</h4>
      </div>
    </div>

    <!-- Card -->
    <div class="card p-3">

      <!-- Attribute Name -->
      <div class="row mb-3">
        <label class="form-label">{{ $t('attribute_name') }} <span class="text-danger">*</span></label>
        <div class="col-md-10">
          <input
            type="text"
            class="form-control"
            v-model="attribute_name"
            placeholder="Attribute Name"
          />
        </div>

        <div class="col-md-2">
          <button
            type="button"
            class="btn btn-submit w-100"
            @click="addAttribute"
          >
            Add
          </button>
        </div>

      </div>

      <!-- Value List -->
      <div class="mb-3">
        <span
          v-for="(val, index) in attributes"
          :key="index"
          class="badge bg-light text-dark border me-1 mb-1"
        >
          {{ val.name }}
          <i
            class="ms-2 text-danger"
            style="cursor:pointer"
            @click="removeAttribute(index)"
          >x</i>
        </span>
      </div>

      <!-- Submit -->
      <div class="d-flex justify-content-end">
        <button
          class="btn btn-cancel me-2"
          @click="cancelForm"
        >
          Cancel
        </button>

        <button
          class="btn btn-submit"
          @click="submitAttributes"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import apiUrls from "@/urls";
import {useToast} from "vue-toastification";

export default {

  data() {
    return {
      attribute_name: "",
      attributes: []
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  methods: {

    addAttribute() {
      const name = this.attribute_name.trim();

      if (!name) {
        return;
      }

      const exists = this.attributes.some(
        item => item.name.toLowerCase() === name.toLowerCase()
      );

      if (exists) {
        this.toast?.error?.("Attribute already added");
        return;
      }

      this.attributes.push({
        name
      });

      this.attribute_name = "";
    },

    removeAttribute(index) {
      this.attributes.splice(index, 1);
    },

    resetForm() {
      this.attribute_name = "";
      this.attributes = [];

    },

    cancelForm() {
      this.$router.push('/attribute/list');
    },

   async submitAttributes() {

      if (!this.attributes.length) {
        this.toast?.error?.(
          "Please add at least one attribute"
        );
        return;
      }

      try {

        await this.$axios.post(apiUrls.attribute.post, this.attributes);

        this.toast?.success?.(
          "Attributes created successfully"
        );

        this.$router.push('/attribute/list');

      } catch (error) {

        console.log(error.response?.data);

        this.toast?.error?.(
          "Failed to create attributes"
        );

      }
    },
  }
};
</script>
